import { URI } from "langium";

export const BUILTIN_LIBRARY = `
module Builtin

scalar Float.[
  const:float
  lt:float
  gt:float
  lte:float
  gte:float
  positive: boolean
  nonnegative: boolean
  negative: boolean
  nonpositive: boolean
]

scalar Int.[
  const:int
  lt:int
  gt:int
  lte:int
  gte:int
  positive: boolean
  nonnegative: boolean
  negative: boolean
  nonpositive: boolean
]

scalar String.[
  const:string
  max:int
  min:int
  length:int
  nonempty:boolean
  pattern:string
  email:boolean
  uuid:boolean
  prefix:string
  suffix:string
  url:boolean
  nanoid:boolean
]

scalar Boolean.[
  const:boolean
]

scalar Binary.[
  min:int
  min_kb:float
  min_mb:float
  max:int
  max_kb:float
  max_mb:float
  nonempty:boolean
]

scalar Time

scalar List<T>.[
  max:int
  min:int
  length:int
  nonempty:boolean
]

scalar Dictionary<T>.[
  max:int
  min:int
  size:int
  nonempty:boolean
]

scalar Union<A B ...>

directive Deprecated(reason?:string)

directive Optional on field

directive Relaxed on struct exception

directive Incremental on enum
`;

export const BUILTIN_LIBRARY_URI = URI.parse("iproto:///builtin.iproto").toString();
